$(function(){
  $(".rte h2").first().before("<div id='toc-shopify' class='toc-shopify'><p class='toc-title'>目次</p><ul></ul></div>")
    let counter = 1;
  $(".rte h2").each(function() {
    let toclink = "toclink" + counter;
  $(this).attr("id", toclink);
    let toctext = $(this).text();
    let element = "<li><a href='#" + toclink + "' class='table-link'>" + toctext + "</a></li>";
  $("#toc-shopify ul").append(element);
    counter++;
  });
  $('a[href^="#"]').click(function(){
    let speed = 800;
    let href= $(this).attr("href");
    let target = $(href == "#" || href == "" ? 'html' : href);
    let position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});